import Swiper, { Lazy, Navigation, Pagination } from 'swiper';
const DEFAULT_GAP_MOBILE = 15;
const DEFAULT_GAP_DESKTOP = 20;
const readGap = (value, fallback)=>{
    const gap = Number(value);
    return value !== undefined && value !== '' && Number.isFinite(gap) ? gap : fallback;
};
export const init = async function() {
    const sliders = document.querySelectorAll('.js-more-to-explore');
    if (sliders.length === 0) return;
    // configure Swiper to use modules
    Swiper.use([
        Lazy,
        Navigation,
        Pagination
    ]);
    sliders.forEach((slider)=>{
        // Already initialised (e.g. init called twice)
        if (slider.classList.contains('swiper-initialized')) return;
        var _slider_querySelector, _slider_querySelector1, _slider_querySelector2;
        new Swiper(slider, {
            pagination: {
                el: (_slider_querySelector = slider.querySelector('.swiper-pagination')) !== null && _slider_querySelector !== void 0 ? _slider_querySelector : undefined,
                type: 'progressbar'
            },
            navigation: {
                nextEl: (_slider_querySelector1 = slider.querySelector('.swiper-button-next')) !== null && _slider_querySelector1 !== void 0 ? _slider_querySelector1 : undefined,
                prevEl: (_slider_querySelector2 = slider.querySelector('.swiper-button-prev')) !== null && _slider_querySelector2 !== void 0 ? _slider_querySelector2 : undefined
            },
            // Enable lazy loading
            lazy: {
                loadPrevNext: true
            },
            slidesPerView: 1.7,
            centeredSlides: false,
            loop: false,
            spaceBetween: readGap(slider.dataset.gapMobile, DEFAULT_GAP_MOBILE),
            breakpoints: {
                1024: {
                    // 2.9 is mirrored in the _more-to-explore.scss file into &-slide {}
                    // to avoid layout shifts. So if slidesPerView changes here, it should
                    // also change there. The gap is the same section setting on both sides.
                    slidesPerView: 2.9,
                    spaceBetween: readGap(slider.dataset.gapDesktop, DEFAULT_GAP_DESKTOP),
                    // Flex layout: the slides are laid out by CSS, nothing to scroll
                    enabled: slider.dataset.flexDesktop !== 'true'
                }
            }
        });
    });
};
